import { render, staticRenderFns } from "./DensityProbHistogram.vue?vue&type=template&id=1969b1bf&scoped=true&"
import script from "./DensityProbHistogram.vue?vue&type=script&lang=js&"
export * from "./DensityProbHistogram.vue?vue&type=script&lang=js&"
import style0 from "./DensityProbHistogram.vue?vue&type=style&index=0&id=1969b1bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969b1bf",
  null
  
)

export default component.exports